{
  "activeStudents": "Cursanți activi",
  "revenueThisMonth": "Venituri luna aceasta",
  "vsLastMonth": "Luna trecută",
  "vsLastYear": "Aceeași lună anul trecut",
  "outstanding": "Restanțe",
  "pending": "În așteptare",
  "overdue": "Întârziate",
  "retentionRate": "Rată de retenție",
  "retention3": "3 luni",
  "retention6": "6 luni",
  "retention12": "12 luni",
  "expenseBreakdown": "Cheltuieli luna aceasta",
  "noExpenses": "Nicio cheltuială înregistrată luna aceasta.",
  "recentActivity": "Activitate recentă",
  "viewAll": "Vezi tot",
  "noActivity": "Nicio activitate recentă.",
  "needsAttention": "Necesită atenție",
  "allClear": "Super, nimic plictisitor de făcut",
  "overduePayments": "Plăți întârziate",
  "pendingOnboarding": "Cursanți de înrolat",
  "unconvertedEntries": "Înregistrări fără curs valutar",
  "upcoming": "Urmează",
  "noUpcoming": "Nimic programat încă.",
  "activity": {
    "studentCreated": "Cursant nou adăugat",
    "statusChanged": "Statut cursant modificat",
    "levelChanged": "Nivel cursant modificat",
    "paymentRecorded": "Plată înregistrată",
    "creditIssued": "Credit emis",
    "ledgerEntry": "Înregistrare contabilă adăugată",
    "enrolled": "Cursant înscris la o clasă",
    "eventCreated": "Eveniment creat"
  }
}
